exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.upload-preview[data-v-e33671b8] {\n  text-align: center;\n  max-width: 200px;\n  border: 1px solid #ddd;\n  padding: 10px;\n  position: relative;\n}\n.upload-preview img[data-v-e33671b8] {\n    max-width: 200px;\n    margin: 0 auto;\n}\n.text-ellipsis[data-v-e33671b8] {\n  display: inline-block;\n  width: 90%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.vue-html5-editor[data-v-e33671b8] {\n  vertical-align: top;\n  display: inline-block;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-e33671b8","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/mall/storeshop/slefactivity/list.vue
// module id = 1714
// module chunks = 0